import { render } from "./DashboardTopUp.vue?vue&type=template&id=333d74fe"
import script from "./DashboardTopUp.vue?vue&type=script&lang=js"
export * from "./DashboardTopUp.vue?vue&type=script&lang=js"
script.render = render

export default script